
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandOe as ObiOwnShipNoCommandOeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-oe.js';
 
 
 

 
 export const ObiOwnShipNoCommandOe = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-oe',
   elementClass: ObiOwnShipNoCommandOeElement,
   events: {
     
   }
  });
 
 